import { createSelector } from '@reduxjs/toolkit';
import { getDayPartMenuConfig } from './config';
import getItems from './getItems';
import checkStagePurchaseAvailability from '../utils/ordering/checkStagePurchaseAvailability';
import getOrderDateTimeSelected from './getOrderDateTimeSelected';

export default (purchaseWithTotals?: PurchaseWithTotals) =>
  createSelector(
    [getDayPartMenuConfig, getItems, getOrderDateTimeSelected],
    (daypartConfig, items, dateTimeSelected): boolean => {
      return checkStagePurchaseAvailability(
        purchaseWithTotals,
        items,
        daypartConfig,
        dateTimeSelected,
      );
    },
  );
